<template>
  <div>
    <div
      class="row movie mt-2"
      @click="selectMovie"
    >
      <div class="col-12">
        <div class="cf-checkbox">
          {{ $props.selectedValue }}
        </div>
        <label>{{ $props.movie.name }}</label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Movie',
  props: {
    movie: {
      type: Object,
      default: null
    },
    selectedValue: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {}
  },
  created () {
  },
  methods: {
    selectMovie () {
      this.$emit('changeSelection', { value: (this.$props.selectedValue + 1) % 3, movie: this.$props.movie.id })
    }
  }
}
</script>
